<template>
  <!-- P16 "Cijeli dan": muted category label, rows of [circle][bold count]
       [name]. Selection is the accent (category colors retired, owner
       2026-07-10). -->
  <div>
    <!-- Content-sized up to the cap — a short list must not open a tall
         empty block (the cap only clamps long lists into a scroll). -->
    <div
      class="hide-scrollbar overflow-auto px-1 pt-2"
      :style="{ maxHeight: `${height}px` }"
    >
      <div
        v-for="category in allItems"
        :key="category.id"
      >
        <div class="text-helper text-muted">{{ category.name }}</div>

        <button
          v-for="item in category.items"
          :key="item.id"
          type="button"
          class="flex w-full items-center gap-2.5 rounded-input px-1 py-2.5 text-left hover:bg-elevated"
          :class="{ 'text-(--app-text-accent)': itemsIds.includes(item.id) }"
          @click="emit('update-items', item)"
        >
          <span
            class="selector-circle shrink-0"
            :class="{ selected: itemsIds.includes(item.id) }"
          />

          <span class="w-6 shrink-0 text-right font-extrabold">{{ item.count }}</span>

          <span class="truncate">{{ item.name }}</span>
        </button>
      </div>
    </div>

    <!-- P16: accent text link, centered. -->
    <UButton
      v-if="showAllCountsExtension"
      class="mt-2 mx-auto flex"
      variant="link"
      color="primary"
      :label="$t('kds.drawer.view_all_counts')"
      @click="showAllCounts"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';

import { Category, Item } from '@/composables/useKitchenTicketItems';

const emit = defineEmits(['show-all-counts', 'update-items']);

const props = defineProps({
  height: {
    type: [Number],
    default: 264,
  },
  selectedItems: {
    type: Array as PropType<Item[]>,
    default: () => [],
  },
  allItems: {
    type: Array as PropType<Category[]>,
    default: () => [],
  },
  limited: {
    type: Boolean,
    default: true,
  }
});

const itemsIds = computed(() => {
  const copyOfTheSelectedItems = [...props.selectedItems];

  const mappedSelecttedItems = copyOfTheSelectedItems.map((item) => item.id);

  return mappedSelecttedItems;
});

const showAllCountsExtension = computed(() => {
  if (props.height > 264) return false;

  const itemsLenght = props.allItems[0] ? props.allItems[0].items.length : 0;

  return props.allItems.length >= 2 || (props.allItems.length && itemsLenght >= 6)
});

const showAllCounts = () => {
  emit('show-all-counts');
};
</script>

<style lang="scss" scoped>
/* P16 selector circle: quiet outline; the selected state flips to an
 * accent radio-dot (ring drawn with an inset bg-colored shadow). */
.selector-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid var(--ui-border-accented);
}

.selector-circle.selected {
  border-color: var(--app-text-accent);
  background: var(--app-text-accent);
  box-shadow: inset 0 0 0 3px var(--ui-bg);
}
</style>
